import { useState } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { MoneyInput, Notice } from "../../lib/ui";

/* Register a fixed asset – port of asset_register.php (API: POST /api/assets, backend/assets.py) */

const BLANK = { asset_name: "", asset_type: "", purchase_date: "", purchase_cost: "", depreciation_method: "", useful_life_years: "",
  salvage_value: "0.00", current_value: "", location: "", status: "In Use" };

export default function AssetRegister() {
  const api = useApi();
  const [f, setF] = useState(BLANK);
  const [notice, setNotice] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const setMoney = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true); setNotice(null);
    try { const r = await api.post("/api/assets", f); setNotice({ tone: "ok", text: r.message }); setF(BLANK); }
    catch (err) { setNotice({ tone: "err", text: err.message }); }
    finally { setBusy(false); }
  };

  return (
    <main className="pg" style={{ maxWidth: "50rem" }}>
      <PageHeader slug="asset_register" actions={<Link to="/assets" className="btn"><i className="fas fa-list" /> Fixed assets</Link>} />
      <Notice notice={notice} onClose={() => setNotice(null)} />
      <div className="panel">
        <form className="form" onSubmit={save} style={{ maxWidth: "none" }}>
          <div className="field"><label htmlFor="ar-n">Asset name<span className="req">*</span></label><input id="ar-n" required value={f.asset_name} onChange={set("asset_name")} /></div>
          <div className="field"><label htmlFor="ar-t">Asset type</label><input id="ar-t" value={f.asset_type} onChange={set("asset_type")} /></div>
          <div className="field"><label htmlFor="ar-d">Purchase date<span className="req">*</span></label><input id="ar-d" type="date" required value={f.purchase_date} onChange={set("purchase_date")} /></div>
          <div className="field"><label htmlFor="ar-c">Purchase cost (TZS)<span className="req">*</span></label><MoneyInput id="ar-c" required value={f.purchase_cost} onChange={setMoney("purchase_cost")} /></div>
          <div className="field"><label htmlFor="ar-m">Depreciation method</label>
            <select id="ar-m" value={f.depreciation_method} onChange={set("depreciation_method")}>
              <option value="">Select method</option><option>Straight Line</option><option>Declining Balance</option></select></div>
          <div className="field"><label htmlFor="ar-l">Useful life (years)</label><input id="ar-l" type="number" min="1" value={f.useful_life_years} onChange={set("useful_life_years")} /></div>
          <div className="field"><label htmlFor="ar-s">Salvage value (TZS)</label><MoneyInput id="ar-s" value={f.salvage_value} onChange={setMoney("salvage_value")} /></div>
          <div className="field"><label htmlFor="ar-v">Current value (TZS)</label><MoneyInput id="ar-v" value={f.current_value} onChange={setMoney("current_value")} /></div>
          <div className="field"><label htmlFor="ar-loc">Location</label><input id="ar-loc" value={f.location} onChange={set("location")} /></div>
          <div className="field"><label htmlFor="ar-st">Status</label>
            <select id="ar-st" value={f.status} onChange={set("status")}><option>In Use</option><option>Retired</option><option>Under Repair</option><option>Disposed</option></select></div>
          <div className="form-actions"><button type="submit" className="btn primary" disabled={busy}><i className="fas fa-floppy-disk" /> {busy ? "Saving…" : "Save asset"}</button></div>
        </form>
      </div>
    </main>
  );
}
